import EventPage from '@/pages/marketing/event-page';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/event/$id')({
  component: EventPage,
});